import { render, staticRenderFns } from "./ProjectLookback.vue?vue&type=template&id=94dbb780&scoped=true&"
import script from "./ProjectLookback.vue?vue&type=script&lang=ts&"
export * from "./ProjectLookback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dbb780",
  null
  
)

export default component.exports